<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Pinned Message</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/pinnedmsgs" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createPinnedMsg" v-if="pinnedMsg">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12" v-if="corps.length">
                        <fg-select
                          v-model="pinnedMsg.corporationId"
                          label="Select Corporation"
                          :list="corps"
                          selectedKey="corporationId"
                          v-validate="rules.corporationId"
                          data-vv-name="Corproration"
                          cus-name="Corporation"
                          :has-errors="errors"
                          :is-fields="fields"
                        >
                        </fg-select>
                      </div>
                      <div class="col-12">
                        <fg-text-area type="text"
                                  v-model="pinnedMsg.corpAdminMessage"
                                  label="Pinned Message"
                                  placeholder="Enter Message"
                                  v-validate="rules.corpAdminMessage"
                                  data-vv-name="Pinned Message"
                                  cus-name="Pinned Message"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-text-area>
                      </div>
                      <div class="col-4">
                        <fg-input type="text"
                                  v-model="pinnedMsg.msgSenderName"
                                  label="Sender Name"
                                  placeholder="Enter Name"
                                  v-validate="rules.msgSenderName"
                                  data-vv-name="Sender Name"
                                  cus-name="Sender Name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-4">
                        <label>Published Date</label>
                        <datetime v-model="publishDate"
                                  required
                                  input-class="form-control"
                                  label="Publish Date"
                                  placeholder="Select Date"
                                  type="date"
                                  input-format="DD-MM-YYYY"
                                  auto-continue>
                        </datetime>
                      </div>
                      <div class="col-4" v-if="status.length">
                        <fg-select
                          v-model="pinnedMsg.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Pinned Message
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreatePinnedMsg',
        created (){
    },
    data () {
      let dateTime = new Date();
        return {
            pinnedMsg: {
              corporationId: 0,
              msgSenderName: '',
              corpAdminMessage: '',
              msgSentDate: '',
              active: 1
            },
            corps: [],
            active: 1,
            publishDate: dateTime.toISOString(),
          rules: {
            corporationId: {required: true},
            msgSenderName: {required : true},
            corpAdminMessage: {required : true},
            active: {required: true}
          },
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}]
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        createPinnedMsg () {
          console.log("this.PinnedMsg : ", this.pinnedMsg);
          this.pinnedMsg.msgSentDate =  moment(this.publishDate).format('YYYY-MM-DD');
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_PINNEDMSG', this.pinnedMsg)
                .then((res) => {
                  console.log("ADD_PINNEDMSG res : ", res);
                  if(res) this.showPopup('Success!', 'Pinned Message is successfully created', 'success', ()=>this.$router.push('/admin/pinnedmsgs'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_PINNEDMSG API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
            this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PinnedMsgs/CreatePinnedMsg.vue